import { Facebook, Instagram, Mail, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import styles from "./Footer.module.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        {/* Brand Section */}
        <div className={styles.section}>
          <h3 className={styles.logo}>Nupur Creations</h3>
          <p className={styles.description}>
            Nurturing the next generation of performers and visual artists
            through rigorous training and creative freedom.
          </p>
          <div className={styles.socials}>
            <a
              href="https://instagram.com/nupur_ghosh78"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Instagram size={20} />
            </a>
            <a
              href="https://www.facebook.com/share/187dttcLge/?mibextid=wwXIfr"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Facebook size={20} />
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div className={styles.section}>
          <h4>Quick Links</h4>
          <ul className={styles.links}>
            <li>
              <Link to="/about">About Us</Link>
            </li>
            <li>
              <Link to="/fine-arts">Fine Arts</Link>
            </li>
            <li>
              <Link to="/faculty">Faculty</Link>
            </li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className={styles.section}>
          <h4>Contact Us</h4>
          <ul className={styles.contactList}>
            <li>
              <Phone size={18} /> (804) 551-5374
            </li>
            <li>
              <Mail size={18} /> info@nupurcreations.com
            </li>
          </ul>
        </div>
      </div>

      <div className={styles.bottomBar}>
        <p>
          &copy; {currentYear} Nupur Creations Academy. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
